<template>
  <USelect
    v-if="members.length > 1"
    :model-value="currentId"
    :items="items"
    class="min-w-40"
    @update:model-value="switchTo"
  />
</template>

<script setup lang="ts">
import type { PatientMemberPublic } from '~/types/patient'
import { patientRelationLabel } from '~/constants/patient/relations'

const props = defineProps<{
  currentId: string
  members: PatientMemberPublic[]
}>()

const emit = defineEmits<{
  switched: []
}>()

const items = computed(() => props.members.map((row) => ({
  label: `${row.fullName} · ${patientRelationLabel(row.relation)}`,
  value: row.id,
})))

async function switchTo(id: string) {
  if (!id || id === props.currentId) return
  await $fetch('/api/patient/switch-member', { method: 'POST', body: { patientId: id } })
  emit('switched')
  await refreshNuxtData()
  reloadNuxtApp()
}
</script>
